export default {
  identificationList: [],
  identificationSelected: {},
  identificationsFounded: [],
  identificationSelectedInTable: null,
};
